import type { FunctionComponent } from "react";

import { BaseLink } from "shared/components/common/base-link";

import IconAppStore from "./icon-app-store.svg";
import IconGooglePlay from "./icon-google-play.svg";
import LogoScmpPlus from "./logo-scmp-plus.svg";
import LogoScmp from "./logo-scmp.svg";
import {
  Container,
  ContentContainer,
  CopyrightContainer,
  CopyrightText,
  DownloadContainer,
  DownloadText,
} from "./style";

export type PlusFooterProps = {
  className?: string;
  fixed?: boolean;
  withAppLinkRow: boolean;
};

export const PlusFooter: FunctionComponent<PlusFooterProps> = ({
  className,
  fixed = false,
  withAppLinkRow,
}) => (
  <Container $fixed={fixed} className={className}>
    {withAppLinkRow && (
      <ContentContainer>
        <LogoScmpPlus />
        <DownloadContainer>
          <DownloadText>Read it in the SCMP App</DownloadText>
          <BaseLink pathname="https://scmp.onelink.me/3586748601/43f04bbb">
            <IconAppStore />
          </BaseLink>
          <BaseLink pathname="https://scmp.onelink.me/3586748601/43f04bbb">
            <IconGooglePlay />
          </BaseLink>
        </DownloadContainer>
      </ContentContainer>
    )}
    <CopyrightContainer>
      <CopyrightText>
        Copyright © {new Date().getFullYear()} South China Morning Post Publishers Ltd. All rights
        reserved.
      </CopyrightText>
      <LogoScmp />
    </CopyrightContainer>
  </Container>
);

PlusFooter.displayName = "PlusFooter";
